import React, { useEffect, useState } from 'react';
import { RWebShare } from 'react-web-share';
import {
  ChakraProvider,
  theme,
  Image,
  Flex,
  Box,
  Text,
  Center,
  Button,
} from '@chakra-ui/react';
import CartIcon from '../assets/img/cart.svg';
import ArrowIcon from '../assets/img/arrow_back.svg';
import Carousel from 'react-elastic-carousel';
import ShareIcon from '../assets/img/share.svg';
import DownloadIcon from '../assets/img/save_alt.svg';
import { SelectoionPopUpCard, SingleCartPopUpCard } from './PopUpCards';
import { verifyPayment } from '../apis/payment';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { useHistory } from 'react-router';
import { addPhotoToCart } from '../apis/Cart';
import { ArrowLeftIcon, ArrowRightIcon } from '@chakra-ui/icons';
import { convertProxyObjectToObj } from '../apis/constants';

const ImageSlider = props => {
  const [slideIndex, setSlideIndex] = useState('');
  const [removeCart, RemoveCart] = useState(false);
  const [saveLater, setSaveLater] = useState(false);
  const [filesArray, setFilesArray] = useState([]);

  const history = useHistory();

  const eventDetails = useStoreState(state => state.eventDetails);
  const instantCheckout = useStoreState(state => state.eventDetails);
  const handleInstantCheckout = useStoreActions(
    action => action.handleInstantCheckout
  );
  const isUserLogged = useStoreState(state => state.isUserLogged);
  const userProfile = useStoreState(state => state.userProfile);

  const tempCart = useStoreState(state => state.tempCart);
  const handleTempCart = useStoreActions(action => action.handleTempCart);
  const handleSingleLevelTempCart = useStoreActions(
    action => action.handleSingleLevelTempCart
  );
  const resetTempCart = useStoreActions(action => action.resetTempCart);
  const resetInstantCheckout = useStoreActions(
    action => action.resetInstantCheckout
  );

  const KeepItCartBtn = () => {
    removeCart === false ? RemoveCart(true) : RemoveCart(false);
  };

  const RemoveCartBtn = id => {
    let transData = convertProxyObjectToObj(tempCart);

    if (Boolean(transData?.length)) {
      transData.splice(id, 1);
      handleSingleLevelTempCart(transData);
    }
  };

  // const addItem = () => {
  //   const nextItem = Math.max(1, items?.length + 1);
  //   setItems([...items, nextItem]);
  // };

  // const removeItem = () => {
  //   const endRange = Math.max(0, items?.length - 1);
  //   setItems(items.slice(0, endRange));
  // };

  const checkUser = image => {
    if (tempCart?.length) {
      resetTempCart([]);
    }

    handleTempCart(image);

    if (!isUserLogged) {
      history.push({
        pathname: `${process.env.PUBLIC_URL}/login-checkout`,
        state: { isPurchaseAll: false },
      });
      return null;
    }

    // get a picture price
    let price = parseFloat(eventDetails.per_photo_price) * 100;

    const data = fetch('http://localhost:1337/local-razorpay', {
      method: 'POST',
      body: JSON.stringify({
        amount: price,
      }),
    }).then(t => t.json());

    const options = {
      key: 'rzp_live_g7QxhlM8a9lWHl',
      currency: data.currency,
      amount: price,
      name: 'Memzo API',
      description: 'Test Wallet Transaction',
      image: 'https://snapwrap.io/img/favicon.png',
      order_id: data.id,
      handler: function (response) {
        //   alert(response.razorpay_payment_id);
        buyPhotos(response.razorpay_payment_id);
        //   alert(response.razorpay_order_id);
        //   alert(response.razorpay_signature);
      },
      prefill: {
        name: '',
        email: '',
        contact: '',
      },
    };

    const paymentObject = new window.Razorpay(options);

    if (paymentObject) {
      paymentObject.open();
    }
  }; 

  const buyPhotos = paymentId => {
    let perPricePhoto = Number(eventDetails.per_photo_price); // in case of single purchase paid amount would be the single picture amount
    // let paidAmount = props.ImageArray?.length * perPricePhoto;
    let imageNameCollection = props.ImageArray.filter(
      (image, index) => index === slideIndex
    );
    let itemToBePurchased = [];
    itemToBePurchased.push(imageNameCollection[0].image_name);
    let slug = JSON.stringify({
      api: userProfile.api_key,
      userId: userProfile.user_profile_id,
      eventId: eventDetails.id,
    });
    console.log('ERRORSINGLE', itemToBePurchased);
    slug = encodeURIComponent(slug);
    if (isUserLogged) {
      verifyPayment(
        userProfile.api_key,
        eventDetails.id,
        userProfile.user_profile_id,
        paymentId,
        perPricePhoto,
        '0',
        itemToBePurchased,
        0
      ).then(response => {
        if (!response.error) {
          history.push(`${process.env.PUBLIC_URL}/download-photos/${slug}`);
          resetTempCart([]);
          resetInstantCheckout([]);
        } else {
          alert(`Error : ${response.message}`);
        }
      });
    } else {
      handleInstantCheckout({
        api: userProfile.api_key,
        userId: userProfile.user_profile_id,
        eventId: props.id,
      });
      history.push({
        pathname: `${process.env.PUBLIC_URL}/login-checkout`,
        state: { isPurchaseAll: false },
      });
    }
  };

  function saveImagesToCart() {
    let imageNameCollection = props.ImageArray.filter(
      (image, index) => index === slideIndex
    );

    if (isUserLogged) {
      handleTempCart(imageNameCollection[0]);
      addPhotoToCart(
        userProfile.api_key,
        eventDetails.id,
        userProfile.user_profile_id,
        imageNameCollection,
        eventDetails.per_photo_price
      ).then(response => {
        response.error
          ? alert(`Error : ${response.message}`)
          : setSaveLater(true);
      });
    } else {
      //save-selection with otp screen...
      // send otp api call
      // save -selection-otp screen
      // cart screen [login user]
      handleInstantCheckout({
        api: userProfile.api_key,
        userId: userProfile.user_profile_id,
        eventId: eventDetails.id,
        cart: imageNameCollection,
        price: eventDetails.per_photo_price,
      });

      history.push(`${process.env.PUBLIC_URL}/login-selection`);
    }
  }

  const SaveLaterBtn = () => {
    if (saveLater === false) {
      setSaveLater(true);
    } else {
      setSaveLater(false);
      if (window.location.hash === '#selection-success') {
        window.location = window.location.href.replace(
          '#selection-success',
          ''
        );
      }
    }
    // window.location.reload();
  };

  const downloadimage = () => {
    let imageNameCollection = props.ImageArray.filter(
      (image, index) => index === slideIndex
    );
    let image = imageNameCollection[0].large_image;
    window.location.href = image;
  };

  const urlToObject = async url => {
    const response = await fetch(url);
    const blob = await response.blob();
    const file = new File([blob], 'image.jpg', { type: blob.type });
    return file;
  };

  const handleOnSubmit = async image => {
    if ('canShare' in navigator) {
      let imageNameCollection = props.ImageArray.filter(
        (image, index) => index === slideIndex
      );
      image = imageNameCollection[0].large_image;
     let invitetext=`Here is my photo from ${eventDetails.event_name}. I found it on memzo. ${"\n"}`;
      //'https://dummyimage.com/600x400/000/fff';
      // here image is url/location of image
      if (navigator.share) {
        await navigator
          .share({
            text: invitetext,
            url: image,
          })
          .then(() => console.log('Successful share'))
          .catch(error => console.log('Error in sharing', error));
      } else {
        console.log(`system does not support sharing files.`);
      }
      // const file = await urlToObject(image);
      // // here image is url/location of image
      // console.log('file');
      // console.log(file);
      // if (navigator.share && navigator.canShare({ files: [file] })) {
      //   await navigator
      //     .share({
      //       files: [file],
      //     })
      //     .then(() => console.log('Successful share'))
      //     .catch(error => console.log('Error in sharing', error));
      // } else {
      //   console.log(`system does not support sharing files.`);
      // }
    } else {
      console.log(`not support`);
    }
  };

  // useEffect(() => {
  //   if (navigator.share === undefined) {
  //     if (window.location.protocol === 'http:') {
  //       window.location.replace(
  //         window.location.href.replace(/^http:/, 'https:')
  //       );
  //     }
  //   }
  // }, []);

  async function testWebShare(imgUrl) {
    let files;
    // Test compatibility
    if (navigator.share === undefined) {
      alert('Unsupported share feature');
      return;
    }

    // Handle file urls
    if (imgUrl) {
      const filesGetter = urlToObject(imgUrl);
      const newFiles = await Promise.all(filesGetter);
      files = newFiles;
      setFilesArray(files);
    }

    // Share content
    if (navigator.canShare && navigator.canShare({ files })) {
      navigator
        .share({
          files,
          title: 'Event Photos',
          text: 'Event Photos - Memzp',
        })
        .then(() => alert('Share was successful.'))
        .catch(error => alert('Sharing failed', error));
    } else {
      console.log(`Your system doesn't support sharing files.`);
    }
  }

  useEffect(() => {
    setSlideIndex(props.CurrentIndex);
  }, []);

  return (
    <ChakraProvider theme={theme}>
      <Flex
        flexDirection="column"
        position="fixed"
        h="auto"
        zIndex="2"
        top="0"
        bg="white"
        zIndex="912"
        className="resopnsive-img-cntr"
      >
        <Flex
          alignItems="center"
          justifyContent="space-between"
          boxShadow="0px 10px 40px 0px rgb(0 0 0 / 12%)"
          mb="15px"
        >
          <Box pt="4" pb="4" pl="4">
            <Image
              src={ArrowIcon}
              alt="Arrow Icon"
              w="4"
              h="4"
              onClick={() => props.CloseBtn(true, 0)}
            />
          </Box>
          <Box pt="4" pb="4" pl="6">
            <Text
              fontSize={15}
              color="#222222"
              fontWeight={400}
              textAlign={'center'}
            >
              {slideIndex + 1} / {props.ImageArray?.length}
            </Text>
          </Box>
        
          <Box pt="4" pb="4" pr="4">
          { eventDetails.is_b2b_prepaid == 0 && ( 
            <Center>
              <Flex
                mt="-5"
                alignItems="center"
                justifyContent="center"
                ml="-3"
                w="18px"
                h="18px"
                bg="#FA2F45"
                borderRadius="40"
                position="absolute"
              >
                <Text color="white" fontSize="11px" fontWeight="700">
                  {tempCart?.length}
                </Text>
              </Flex>
              <Image src={CartIcon} alt="Cart Icon" w="6" h="6" />
              <Text
                fontSize={15}
                fontWeight={400}
                color="#000000"
                pl="2"
                pt="1"
              >
                &#8377;{' '}
                {Number(eventDetails.per_photo_price * tempCart?.length)}
              </Text>
            </Center>
            )}
          </Box>
           
        </Flex>
        
        {saveLater ? <SelectoionPopUpCard SaveBtn={SaveLaterBtn} /> : null}

        <Flex
          bg="#efefef"
          w="100%"
          h="85vh"
          style={
            props.Status === 'Cart'
              ? { paddingTop: '14px' }
              : { paddingTop: '0px' }
          }
        >
          <Carousel
            initialActiveIndex={props.CurrentIndex}
            onChange={(i, indx) => setSlideIndex(indx)}
           
            
          >
            {props.ImageArray.map((item, index) => (
              <>
                <Flex
                  key={item.large_image}
                  title={item.large_image}
                  flexFlow="row"
                  alignItems="center"
                >
                  <Flex className="image-slide-show">
                    <ArrowLeftIcon
                      w={6}
                      h={6}
                      position="fixed"
                      left="25%"
                      color="#f4433614"
                     
                    />
                  </Flex>
                  <Image
                    key={index + item.image_name}
                    fallbackSrc="https://via.placeholder.com"
                    src={item.large_image}
                    alt={index}
                    objectFit="contain"
                    style={{maxHeight:"85vh", margin:"auto"}}
                  />
                  <Flex className="image-slide-show">
                    <ArrowRightIcon
                      w={6}
                      h={6}
                      position="fixed"
                      right="25%"
                      color="#f4433614"
                    />
                  </Flex>
                </Flex>
                <Flex
                  className="screen-bottom-cntr2"
                  justifyContent="space-between"
                  bg="white"
                  position="fixed"
                  bottom="0"
                  width="100vW"
                  left="0"
                  pl="2"
                  pr="2"
                  boxShadow="0px 8px 3px 6px #e7e5e5"
                >
                  {/* ------------------------Gallery Button------------------------ */}
                  {props.Status === 'AllGallery' && eventDetails.is_b2b_prepaid == 0 && (
                    <Flex
                      justifyContent="space-between"
                      w="100%"
                      pt="4"
                      pl="3"
                      pr="3"
                      pb="4"
                    >
                      <Button
                        color="#FA2F45"
                        bg="white"
                        h="10"
                        borderRadius="40"
                        border="1px solid #FA2F45"
                        onClick={() => checkUser(item)}
                      >
                        Buy this Photo
                      </Button>
                      <Button
                        color="white"
                        bg="#FA2F45"
                        h="10"
                        pl="6"
                        pr="6"
                        borderRadius="40"
                        onClick={() => saveImagesToCart(item)}
                      >
                        Add to Cart
                      </Button>
                    </Flex>
                  )}

                  {/* ------------------------Gallery with Prepaid mode Button------------------------ */}
                  {props.Status === 'AllGallery' && eventDetails.is_b2b_prepaid == 1 && (
                    <Flex justifyContent="space-between" w="100%" pt="4" pb="4">
                      <Flex alignItems="center">
                        {/* <Image src={ShareIcon} alt="User Icon" w="6" h="6" /> */}

                        <Button
                          color="#999999"
                          bg="white"
                          borderRadius="0"
                          align="center"
                          onClick={e => handleOnSubmit(item.large_image)}
                        >
                          <Image src={ShareIcon} alt="User Icon" w="6" h="6" />
                          <Text pt="1.5" pl="1.5">
                            Share
                          </Text>
                        </Button>
                      </Flex>

                      <Flex alignItems="center">
                        <Button
                          color="#999999"
                          bg="white"
                          // pl="2"
                          // pt="1"
                          borderRadius="0"
                          onClick={e => downloadimage()}
                        >
                          {/* <a onClick={e => downloadimage()} download>
                            {' '}
                            Download
                          </a> */}
                          <Image
                            src={DownloadIcon}
                            alt="User Icon"
                            w="6"
                            h="6"
                          />
                          <Text pt="1.4" pl="1.5">
                            Download
                          </Text>
                        </Button>
                      </Flex>
                    </Flex>
                  )}

                  {/* ------------------------Purchased Button------------------------ */}
                  {props.Status === 'Purchased' && (
                    <Flex justifyContent="space-between" w="100%" pt="4" pb="4">
                      <Flex alignItems="center">
                        {/* <Image src={ShareIcon} alt="User Icon" w="6" h="6" /> */}

                        <Button
                          color="#999999"
                          bg="white"
                          borderRadius="0"
                          align="center"
                          onClick={e => handleOnSubmit(item.large_image)}
                        >
                          <Image src={ShareIcon} alt="User Icon" w="6" h="6" />
                          <Text pt="1.5" pl="1.5">
                            Share
                          </Text>
                        </Button>
                      </Flex>

                      <Flex alignItems="center">
                        <Button
                          color="#999999"
                          bg="white"
                          // pl="2"
                          // pt="1"
                          borderRadius="0"
                          onClick={e => downloadimage()}
                        >
                          {/* <a onClick={e => downloadimage()} download>
                            {' '}
                            Download
                          </a> */}
                          <Image
                            src={DownloadIcon}
                            alt="User Icon"
                            w="6"
                            h="6"
                          />
                          <Text pt="1.4" pl="1.5">
                            Download
                          </Text>
                        </Button>
                      </Flex>
                    </Flex>
                  )}

                  {/* ------------------------Cart Button------------------------ */}
                  {props.Status === 'Cart' && (
                    <Flex justifyContent="space-between" w="100%" pt="4" pb="4">
                      <Button
                        color="#FA2F45"
                        bg="white"
                        h="10"
                        borderRadius="20"
                        border="1px solid #FA2F45"
                      >
                        Buy this Photo
                      </Button>
                      {!tempCart[slideIndex] ? null : (
                        <Button
                          color="white"
                          bg="#FA2F45"
                          h="10"
                          borderRadius="20"
                          onClick={() => KeepItCartBtn()}
                        >
                          Remove from Cart
                        </Button>
                      )}
                    </Flex>
                  )}

                  {/* ------------------------Remove Item Cart------------------------ */}
                  {removeCart && (
                    <SingleCartPopUpCard
                      RemoveSingleItemBtn={RemoveCartBtn}
                      SingleSlideIndex={slideIndex}
                      KeepSingleItBtn={KeepItCartBtn}
                    />
                  )}
                </Flex>
              </>
            ))}
          </Carousel>
        </Flex>
      </Flex>
    </ChakraProvider>
  );
};
export default ImageSlider;
